import { action, makeAutoObservable, toJS } from "mobx";
import {
  defaultFilterTypes,
  filterTypes,
  ProjectWorksPayloadDefaultValues,
  payloadKey,
} from "../../features/project-works-v2";
import { PWV2Props } from "./data";
import _ from "lodash";

export class ProjectWorkStoreV2 {
  rootStore: any;
  projectWorksList = [];
  projectWorksPayload: any;
  add_project_modal: boolean = false;
  delete_project_modal: boolean = false;
  edit_pw_modal: boolean = false;
  add_media_modal: boolean = false;
  edit_media_modal: boolean = false;
  add_fund_modal: boolean = false;
  add_event_modal: boolean = false;
  add_key_contacts: boolean = false;
  cover_photo_path: string = "";
  searchQuery: string = "";
  filters: filterTypes = defaultFilterTypes;
  activeProjectWork: any = {};
  activeMediaModal: any = {};
  activeFundModal: any = {};
  projectWorkFilterModal: boolean = false;
  activeProject: any = {};
  selectedContactToEdit: any = {};
  selectedEventToEdit: any = {};
  selectedFundToEdit: any = {};

  constructor(rootStore: any) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @action
  setProjectWorksPayload = (
    payload,
    key: payloadKey,
    isUpdate: boolean = false
  ) => {
    if (isUpdate) {
      console.log("rec payload");
      console.log(payload);
      if (key === "funds") {
        this.projectWorksPayload.r1.funds.spentbreakdown =
          this.projectWorksPayload.r1.funds.spentbreakdown.map((item) => {
            if (item.id === payload.id) {
              console.log(payload);
              return { ...payload };
            }
            return item;
          });
      } else {
        this.projectWorksPayload.r1[key] = this.projectWorksPayload.r1[key].map(
          (item) => {
            if (item.id === payload.id) {
              return { ...payload };
            }
            return item;
          }
        );
      }
    } else {
      if (key === "funds") {
        this.projectWorksPayload.r1.funds.spentbreakdown = [
          ...(this.projectWorksPayload.r1.funds.spentbreakdown || []),
          payload,
        ];
      } else {
        this.projectWorksPayload.r1[key] = [
          ...(this.projectWorksPayload.r1[key] || []),
          payload,
        ];
      }
    }
    this.setProjectWork(this.projectWorksPayload);
  };
  @action
  setProjectWork = (projectWork) => {
    this.activeProject = projectWork;
    this.projectWorksPayload = _.merge(
      this.activeProject,
      ProjectWorksPayloadDefaultValues
    );
    if (this.projectWorksPayload && this.projectWorksPayload.fst) {
      this.projectWorksPayload.fst.id = this.activeProject?.id;
    }
  };
  @action
  resetFilters = () => {
    this.filters = {
      villages: [],
      status: [],
      start_date: "",
      end_date: "",
    };
  };
  @action
  setSelectedFundToEdit = (fund) => {
    this.selectedFundToEdit = fund;
  };
  @action
  setSelectedEventToEdit = (event) => {
    this.selectedEventToEdit = event;
  };

  @action
  setSelectedContactToEdit = (contact) => {
    this.selectedContactToEdit = contact;
  };

  updateFilters(filters: filterTypes) {
    this.filters = filters;
  }
  toggleProjectWorkFilterModal = () => {
    this.projectWorkFilterModal = !this.projectWorkFilterModal;
  };
  async getProjectWorks(payload, id) {
    return await this.rootStore.api.post("projectworks/search", payload, {
      id: parseInt(id),
    });
  }

  //TODO:2
  @action
  update_add_project_modal = (val) => {
    this.add_project_modal = val;
  };

  @action
  add_project_work = async (payload) => {
    return await this.rootStore.api.post("projectworks/add", payload);
  };

  @action
  edit_project_work = async (payload) => {
    return await this.rootStore.api.post("projectworks/update", payload);
  };

  @action
  async delete_project_work(id) {
    return await this.rootStore.api.post("projectworks/delete", { id: id });
  }

  @action
  update_project_work_property = (key: PWV2Props, value: any) => {
    switch (key) {
      case "set_project_works":
        this.projectWorksList = value;
        break;
      case "activeProjectWork":
        this.activeProjectWork = value;
        break;
      case "activeMediaModal":
        this.activeMediaModal = value;
        break;
      case "activeFundModal":
        this.activeFundModal = value;
        break;
      case "cover_photo":
        this.cover_photo_path = value;
        break;
      case "delete_modal":
        this.delete_project_modal = value;
        break;
      case "edit_pw_modal":
        this.edit_pw_modal = value;
        break;
      case "add_media_modal":
        this.add_media_modal = value;
        break;
      case "edit_media_modal":
        this.edit_media_modal = value;
        break;
      case "add_fund_modal":
        this.add_fund_modal = value;
        break;
      case "searchQuery":
        this.searchQuery = value;
        break;
      case "add_event_modal":
        this.add_event_modal = value;
        break;
      case "add_key_contacts":
        this.add_key_contacts = value;
        break;
    }
  };
}
